import { exceptionHandler } from '@scalefast/core';
export class Handler {
  execute(params) {
    try {
      return this.handle(params);
    } catch (error) {
      throw exceptionHandler(error);
    }
  }
}
